import { render, staticRenderFns } from "./JdsLocaleProvider.vue?vue&type=template&id=2fecc9b8&"
import script from "./JdsLocaleProvider.vue?vue&type=script&lang=ts&"
export * from "./JdsLocaleProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports